import $ from 'jquery'

class Spoiler {
  open=false;
  container;
  titleContainer;
  contentContainer;
  constructor(container, titleContainer, contentContainer) {
    this.container=container;
    this.titleContainer=titleContainer;
    this.contentContainer=contentContainer;

    this.attachEventListeners();
  };
  attachEventListeners() {
    this.titleContainer.on("click", ()=>{
      console.log("click");
      this.toggleContent();
    });
  };
  toggleContent() {
    this.open=!this.open;
    if (this.open) {
      this.container.addClass("open");
      this.contentContainer.slideDown(300);
    } else {
      this.container.removeClass("open");
      this.contentContainer.slideUp(300);
    }
  }
}

$("[data-spoiler]").each(function() {
  new Spoiler($(this),
               $(this).find("[data-spoiler-role=title]"),
               $(this).find("[data-spoiler-role=content]"));
});


